import { ATDLNControlType } from "../enums/atdl-control-type.enum";
import { ATDLNParameterType } from "../enums/atdl-parameter-type.enum";

export class ATDLLayoutControlModel {
  public icdId: string;
  public refName: string;
  public icdType: ATDLNControlType;
  public paramType: ATDLNParameterType;
  public visible: boolean = true;
  public partFillLocked: boolean = false;

  constructor(
    icdId?: string,
    refName?: string,
    icdType?: ATDLNControlType,
    paramType?: ATDLNParameterType,
  ) {
    this.icdId = icdId;
    this.refName = refName;
    this.icdType = icdType;
    this.paramType = paramType;
  }
}
